import { useNavigate, useParams } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive';
import { ChatContent } from '../../layouts/ChatContent'

import { useEffect, useState } from 'react'

import { chatAPI } from '../../api'

import {setTitle} from '../../utils'

import {SharedChatModel} from '../../models'


import {ChatBase} from './ChatBase'

const SharedChatBase = () => {

  const navigate = useNavigate()

  const { sharedChatId } = useParams<{ sharedChatId: string}>();

  const [currentSharedChat, setCurrentSharedChat] = useState<SharedChatModel>()

  useEffect(() => { 
    getSharedChat()
  }, [sharedChatId])

  const getSharedChat = () => {
    if( sharedChatId ){
      chatAPI.getSharedChat(undefined, sharedChatId).then(({data: {data}}) => {
        setCurrentSharedChat(data)
        if (data?.name) {
          setTitle(data.name)
        }
      })
    }
  }

  const goChat = () => {
    navigate(`/c`)
  }

  return (
    <>
      <ChatContent handleStartNewChat={goChat}>
        <ChatBase handleStartNewChat={goChat} currentSharedChat={currentSharedChat}/>
      </ChatContent>
    </>
  )
}

export default SharedChatBase
